




















import Vue from 'vue'
import { mapGetters } from 'vuex'
import { elementHandler, sleep } from '@/utils/helpers'

interface TabItem {
  active: boolean
  icon: string
  label: string
  path: string
  hasBadge?: boolean
  awesome?: boolean
}

export default Vue.extend({
  name: 'AppFooter',
  props: {
    active: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      isReloading: false
    }
  },
  computed: {
    tabItems(): TabItem[] {
      return [
        {
          active: this.isHome,
          icon: 'home',
          label: '一覧',
          path: '/'
        },
        {
          active: this.isMessage,
          icon: 'email',
          label: 'メッセージ',
          path: '/message',
          hasBadge: this.$store.getters['MessageList/hasMessageBadge']
        },
        {
          active: this.isTimeline,
          icon: 'clock',
          label: 'タイムライン',
          path: '/timeline'
        },
        {
          active: this.isFootprint,
          icon: 'paw',
          label: 'あしあと',
          path: '/footprint/list',
          awesome: true
        },
        {
          active: this.isMypage,
          icon: 'user',
          label: 'マイページ',
          path: '/mypage',
          hasBadge: this.$store.getters['Notice/hasNoticeBadge']
        }
      ]
    },

    isHome(): boolean {
      return this.active === 'home'
    },

    isMessage(): boolean {
      return this.active === 'message'
    },

    isTimeline(): boolean {
      return /(timeline|timeline\user)/.test(this.active)
    },

    isFootprint(): boolean {
      return this.active === 'footprint/list'
    },

    isMypage(): boolean {
      return this.active === 'mypage'
    }
  },
  mounted() {
    elementHandler('html').then(html => {
      html.classList.add('has-navbar-fixed-bottom')
    })
  },
  destroyed() {
    elementHandler('html').then(html => {
      html.classList.remove('has-navbar-fixed-bottom')
    })
  },
  methods: {
    /**
     * 指定ページにジャンプ, 同じページならリロード
     */
    async jump(path: string) {
      if (this.isReloading) {
        return
      }

      if (this.$route.path === path) {
        this.isReloading = true
        this.$root.$emit('routerViewKeyChange', new Date().getTime())
        await sleep(500)
        this.isReloading = false
      } else {
        this.$router.push(path)
      }
    }
  }
})
